import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from "react-redux";
import { useLocation  } from "react-router-dom";
import './Dashboard.css';
import Breadcrumb from '../Breadcrumb';
// import DocumentSearchBar from '../DocumentSearchBar/DocumentSearchBar';
import useResizableTable from '../../hooks/useResizableTable';
// import useSortData from '../../hooks/useSortableTable';

const Dashboard = React.memo(
    ({
        isFetching = false,
        isFetchingSearch = false,
        user = {},

        data: searchResults,
        count: searchCount,
        fetchSearchData,

        fetchWhatNewData,
        data_new
    }) => {

        const [searchHeaders, setSearchHeaders] = useState([]);
        const [searchTitle, setSearchTitle] = useState("");
        const [sortedNewData, setSortedNewData] = useState([]);
        const isSearching = searchHeaders.length > 0;
        const tableData = isSearching ? searchResults : sortedNewData;
        const itemsPerPage = 100;
        const [currentPage, setCurrentPage] = useState(1);
        const totalPages = Math.ceil(
            (isSearching ? searchCount : data_new.length) / itemsPerPage
        );
        const [pageGroup, setPageGroup] = useState(0);
        const pagesPerGroup = 10;
        const startPage = pageGroup * pagesPerGroup + 1;
        const endPage = Math.min(startPage + pagesPerGroup - 1, totalPages);

        const dispatch = useDispatch();
        const location = useLocation();

        // const { sortConfig, handleSort, resetSort } = useSortData();

        useResizableTable(searchHeaders);

        useEffect(() => {
            if (location.state?.resetDashboard) {
                dispatch({ type: "CLEAR_DATA_FOLDER" });
                setSearchTitle("");
                setSearchHeaders([]);
                fetchWhatNewData();
                setCurrentPage(1);
                setPageGroup(0);
                // resetSort();  

                window.history.replaceState({}, document.title);
            }
        // eslint-disable-next-line 
        }, [location.state, dispatch, fetchWhatNewData]);

        useEffect(() => {
            setSortedNewData(data_new);
        }, [data_new]);

        const handleSearch = async (title, fixedHeaders) => {
            const trimmed = title.trim();

            // --- CASE: empty keyword ---
            if (!trimmed) {
                setSearchHeaders([]);
                setSearchTitle("");
                searchResults.length = 0;
                setCurrentPage(1);
                setPageGroup(0);
                dispatch({ type: "CLEAR_DATA_FOLDER" });

                // resetSort();  
                fetchWhatNewData();
                return;
            }

            // --- SEARCH CASE ---
            // resetSort();  
            setSearchHeaders(fixedHeaders);
            await fetchSearchData(trimmed);
            setCurrentPage(1);
            setPageGroup(0);
        };

        const hasSearched = searchHeaders.length > 0;

        // --- Get data for current page ---
        const paginatedData = tableData.slice(
            (currentPage - 1) * itemsPerPage,
            currentPage * itemsPerPage
        );


        // ★ SORT HANDLER (SEARCH MODE ONLY)
        // const onSortColumn = (key) => {
        //     if (isSearching) {
        //         // sort searchResults
        //         const sorted = handleSort(key, [...searchResults]);
        //         if (sorted) {
        //             searchResults.splice(0, searchResults.length, ...sorted);
        //         }
        //     } else {
        //         // sort data_new
        //         const sorted = handleSort(key, [...sortedNewData]);
        //         if (sorted) {
        //             setSortedNewData(sorted);
        //         }
        //     }
        // };

        const renderSortableTh = (label, key) => {
            // const isSorted = sortConfig.key === key;
            // const dir = isSorted ? sortConfig.direction : "asc";

            return (
                <th
                    key={key}
                    // onClick={() => onSortColumn(key)}
                    // style={{ cursor: "pointer", userSelect: "none" }}
                    >
                    {label}
                    {/* {isSorted && (
                        <span className="sort-icon">
                            {dir === "asc" ? "▲" : "▼"}
                        </span>
                    )} */}
                </th>
            );
        };

        // ウエンタオ追加ー文書参照画面処理-Start
        const handleDocumentView = (row) => {
            if (!row?.doc_id) return;
            window.open(`/viewId/${row.doc_id}/view`);
        };

        return (
            <div id="Main" className="main">
                <div className='dashboard-container'>
                    {user ? (
                        <Breadcrumb
                            userName={user.user_name}
                            hidePath={true}
                        />
                    ) : (
                        <Breadcrumb style={{ display: 'none' }} />
                    )}

                    {/* ===============================
                        画面タイトル（左上）
                        =============================== */}
                    <div className="dashboard-title">
                        What’s New（全部門の直近100件）
                    </div>
                </div>

                {/* SEARCH BAR */}
                {/* <div style={{ padding: "20px" }}>
                    <DocumentSearchBar
                        value={searchTitle}
                        onChange={setSearchTitle}
                        onSearch={handleSearch}
                    />
                </div> */}

                {/* COUNT */}
                {/* <div className="document-data__count">
                    <span>件数：{searchCount || data_new.length}</span>
                </div> */}

                {/* TABLE */}
                <div className="search-table__container">
                    <table className="search-table__table">
                        <thead>
                            <tr>

                                {!isSearching && (
                                    <>
                                        {renderSortableTh("タイトル", "title")}
                                        {renderSortableTh("フォルダ", "folder_name")}
                                        {renderSortableTh("公開日", "issue_datetime")}
                                        {renderSortableTh("最終更新者", "user_name")}
                                    </>
                                )}

                                {hasSearched && searchHeaders.length > 0 && (
                                    searchHeaders
                                        .sort((a, b) => a.display_idx - b.display_idx)
                                        .map(col =>
                                            renderSortableTh(col.pattern_text, col.pattern_name)
                                        )
                                )}
                            </tr>
                        </thead>

                        <tbody>
                            {paginatedData.length > 0 &&
                                paginatedData.map((row, index) => {
                                    const globalIndex = (currentPage - 1) * itemsPerPage + index;

                                    return (
                                        <tr key={globalIndex}>

                                            {/* タイトル */}
                                            <td title={row.title}>
                                                {row.title ? (
                                                    <span
                                                        className="document-link"
                                                        style={{
                                                            color: "#0091a7",
                                                            textDecoration: "underline",
                                                            cursor: "pointer"
                                                        }}
                                                        onClick={() => handleDocumentView(row)}
                                                    >
                                                        {row.title}
                                                    </span>
                                                ) : (
                                                    ""
                                                )}
                                            </td>

                                            {/* フォルダ ★追加 */}
                                            {!isSearching && (
                                                <td title={row.folder_name}>
                                                {row.folder_name || ""}
                                                </td>
                                            )}

                                            {/* 最終更新日 (issue_datetime) */}
                                            <td title={isSearching ? row.u_datetime : row.issue_datetime}>
                                                {isSearching ? row.u_datetime : row.issue_datetime || ""}
                                            </td>

                                            {/* 最終更新者 */}
                                            <td title={row.user_name}>
                                                {row.user_name || ""}
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>

                    </table>
                </div>

                {/* PAGINATION */}
                {/* <div className="pagination-container">
                    {totalPages > 0 && ( 
                        <div className="pagination">

                            {pageGroup > 0 && (
                                <button className="pagination-arrow" onClick={() => setPageGroup(p => p - 1)}>
                                    &laquo;
                                </button>
                            )}

                            {Array.from({ length: endPage - startPage + 1 }, (_, i) => {
                                const page = startPage + i;
                                return (
                                    <button
                                        key={page}
                                        className={`pagination-btn ${currentPage === page ? "active" : ""}`}
                                        onClick={() => setCurrentPage(page)}
                                        >
                                        {page}
                                    </button>
                                );
                            })}

                            {(pageGroup + 1) * pagesPerGroup < totalPages && (
                                <button className="pagination-arrow" onClick={() => setPageGroup(p => p + 1)}>
                                    &raquo;
                                </button>
                            )}

                        </div>
                    )}

                </div> */}

                <div className={`overlay ${(isFetching || isFetchingSearch) ? "active" : ""}`}>
                    <div className={`spinner ${(isFetching || isFetchingSearch) ? "active" : ""}`}></div>
                </div>
            </div>
        );
    }
);

Dashboard.propTypes = {
    isFetching: PropTypes.bool.isRequired,
    user: PropTypes.object,
    fetchUserData: PropTypes.func.isRequired,
    refreshAccessToken: PropTypes.func.isRequired,

    data: PropTypes.array,
    count: PropTypes.number,
    fetchSearchData: PropTypes.func.isRequired,

    data_new: PropTypes.array,
    fetchWhatNewData: PropTypes.func.isRequired,
};

export default Dashboard;
